
  var _styles = {
  "suggest-area-item-container": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "width": "9.14667rem",
    "height": "1.33333rem",
    "margin": "auto",
    "paddingTop": "0.21333rem",
    "paddingRight": 0,
    "paddingBottom": "0.21333rem",
    "paddingLeft": 0,
    "backgroundColor": "rgb(255,255,255)"
  },
  "suggest-area-item-left": {
    "flexDirection": "row",
    "alignItems": "center"
  },
  "suggest-area-item-right": {
    "flexDirection": "row",
    "alignItems": "center"
  },
  "suggest-area-item-icon": {
    "width": "0.32rem",
    "height": "0.37333rem",
    "marginRight": "0.26667rem"
  },
  "suggest-area-item-title": {
    "width": "5.97333rem",
    "height": "0.90667rem",
    "flexDirection": "column",
    "justifyContent": "space-between"
  },
  "suggest-area-item-tag-text": {
    "fontWeight": "300",
    "fontFamily": "PingFangSC-Light",
    "fontSize": "0.32rem",
    "color": "rgb(89,89,89)",
    "textAlign": "right",
    "lineHeight": "0.4rem"
  }
};



  module.exports = _styles;
  